import { h } from 'preact'

import { buildCategoryPermalink, buildTagPermalink } from '../../../utils/urls'
import { SiteArticleContent } from '../../molecule/ArticleContent'
import ArticleRelated from '../../molecule/ArticleContent/related'
import { LightboxWrapper } from '../../molecule/Lightbox'
import { useMedia, useMounted } from '../../../hooks'

import { Body } from './body'

const Article = (props) => {
  const {
    year,
    month,
    day,
    slug,
    permalink,
    rel = {},
    author = {},
    post = {},
    related = [],
    categories = [],
    tags = [],
  } = props

  const {
    title,
    content,
    date,
    pages,
  } = post

  const mappedTags = tags.map(data => ({
    id: data.id,
    label: data.name,
    permalink: buildTagPermalink(data),
  }))

  const mappedCategories = categories.map(data => ({
    ...data,
    id: data.id,
    label: data.name,
    permalink: buildCategoryPermalink(data),
  }))

  const parsedAuthor = {
    id: author.id,
    url: author.url,
    name: `${author.firstName} ${author.lastName}`,
  }

  return (
    <>
      <LightboxWrapper>
        <SiteArticleContent
          year={year}
          month={month}
          day={day}
          slug={slug}
          noMargin
          meta={{
            permalink,
            title,
            publishedDate: date,
          }}
          author={parsedAuthor}
          categories={mappedCategories}
          tags={mappedTags}
          rel={rel}
          pages={pages}
        >
          <Body content={content} />
        </SiteArticleContent>
      </LightboxWrapper>

      {related.length ? <InlineRelatedEntries related={related} /> : null}
    </>
  )
}

const InlineRelatedEntries = (props) => {
  const isMounted = useMounted()
  const { matches: isDesktop } = useMedia('screen and (min-width: 1280px)')

  if (!isMounted || !isDesktop) {
    return null
  }

  return <ArticleRelated {...props} />
}

export default Article
